import { render, staticRenderFns } from "./AffiliateDetailModal.vue?vue&type=template&id=94f04658&scoped=true"
import script from "./AffiliateDetailModal.vue?vue&type=script&lang=js"
export * from "./AffiliateDetailModal.vue?vue&type=script&lang=js"
import style0 from "./AffiliateDetailModal.vue?vue&type=style&index=0&id=94f04658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f04658",
  null
  
)

export default component.exports